// extracted by mini-css-extract-plugin
export default {"Box":"SubIssuesList-module__Box--Gjjw_","ButtonGroup":"SubIssuesList-module__ButtonGroup--zLqq7"};